import { fullWidthStyles } from "components/components/FullWidthSection/style";
import styled from "styled-components";

export const WideTabContainer = styled.div`
  ${fullWidthStyles};
  padding: 0 1%;
`;
